<template>
  <van-tabbar v-model="active" active-color="#ee0a24" @change="onChange" class="custom-tabbar">
    <van-tabbar-item icon="home-o" name="home">首页</van-tabbar-item>
    <!-- <van-tabbar-item icon="star-o" name="member">会员卡券</van-tabbar-item> -->
    <!-- <van-tabbar-item icon="search" name="meituan">美团团购</van-tabbar-item> -->
    <!-- <van-tabbar-item icon="chat-o" name="taobao">淘宝团购</van-tabbar-item> -->
    <van-tabbar-item icon="shopping-cart-o" name="shop">
      电商购物
      <template #badge>
        <div class="custom-badge"></div>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { ref } from 'vue';
import { Tabbar, TabbarItem } from 'vant';

export default {
  name: 'BottomTabBar',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
  },
  props: {
    defaultActive: {
      type: [Number, String],
      default: 'shop'
    }
  },
  emits: ['change'],
  setup(props, { emit }) {
    const active = ref(props.defaultActive);

    const onChange = (name) => {
      emit('change', name);
    };

    return {
      active,
      onChange
    };
  }
};
</script>

<style scoped>
.custom-tabbar {
  height: 60px; /* 增加高度 */
  padding-bottom: 5px; /* 适配底部安全区 */
}

.custom-badge {
  position: absolute;
  top: 0;
  right: 10px;
  width: 8px;
  height: 8px;
  background: #ee0a24;
  border-radius: 50%;
}

:deep(.van-tabbar-item__text) {
  font-size: 14px; /* 增大文字 */
  margin-top: 4px;
}

:deep(.van-tabbar-item__icon) {
  font-size: 24px; /* 增大图标 */
}

/* 调整图标容器的边距，避免拥挤 */
:deep(.van-tabbar-item__icon) {
  margin-bottom: 4px;
}
</style>
